export default "__VITE_ASSET__BMY2aUhp__"